import {
  TagFragment,
  Button,
  Collection,
  Facts,
  Features,
  Iframe,
  Media,
  PullQuote,
  Table,
  TeaserBlock,
  Video,
  VideoExternal
} from '~/graphql/fragments'
import { type ResultOf, graphql } from '~/lib/datocms/graphql'

export const queryJob = graphql(
  /* GraphQL */ `
    query Job($slug: String) {
      job(filter: { slug: { eq: $slug } }) {
        _seoMetaTags {
          ...TagFragment
        }
        __typename
        _modelApiKey
        createdAt
        id
        excerpt
        leadText
        time
        location
        body {
          blocks {
            ... on RecordInterface {
              id
              _modelApiKey
              __typename
            }
            ...Button
            ...Collection
            ...Facts
            ...Features
            ...Iframe
            ...Media
            ...PullQuote
            ...Table
            ...TeaserBlock
            ...Video
            ...VideoExternal
          }
          links {
            ... on RecordInterface {
              id
              _modelApiKey
              __typename
            }
            ... on ArticleRecord {
              slug
              title
            }
            ... on PageRecord {
              title
              slug
            }
            ... on WorkRecord {
              slug
              title
            }
          }
          value
        }
        title
        slug
      }
    }
  `,
  [
    TagFragment,
    Button,
    Collection,
    Facts,
    Features,
    Iframe,
    Media,
    PullQuote,
    Table,
    TeaserBlock,
    Video,
    VideoExternal
  ]
)

type JobResult = NonNullable<ResultOf<typeof queryJob>['job']>

export type JobBodyRecord = JobResult['body']['links'][0]
export type JobBodyBlock = JobResult['body']['blocks'][0]
